
<div [formGroup]="form()">
  <ci-text-field-outlined 
    class="form-field--time"
    type="time"
    [value]="getCurrentValue()"
    [min]="minTime"
    [max]="maxTime"
    [step]="30"
    [label]="getLabel() | translate"
    [placeholder]="getLabel() | translate"
    (input)="handleInput($event)"
  ></ci-text-field-outlined>
</div>